module.exports = __webpack_public_path__ + "img/home_top.1034af76.png";